import dayjs from 'dayjs';

export const DateIntervalWindowFormats = {
  UtcDaily: 'MM-DD',
  UtcHourly: 'MM-DDTHH:mm',
  UtcMonthly: 'YYYY-MM',
  Daily: 'MMM DD',
  Hourly: 'MMM DD HH:mm',
  Monthly: 'MMM YYYY',
} as const;

export type DateIntervalWindowFormat =
  (typeof DateIntervalWindowFormats)[keyof typeof DateIntervalWindowFormats];

/**
 * Formats a date based on the interval window provided.
 * @param {string} value - the data value to format.
 * @param {DateIntervalWindowFormat} format - format to use from DateIntervalWindowFormats.
 * @param {boolean} isUtc - whether return date in utc
 * @return {string} - return the formatted date as a string.
 */
export const dateFormatByIntervalWindow = (
  value: string,
  format: DateIntervalWindowFormat,
  isUtc: boolean,
): string => {
  const date = dayjs.utc(value);
  if (!date.isValid()) return value;
  if (isUtc) return date.format(format);

  return date.local().format(format);
};
